import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Lock, Unlock } from "lucide-react";

export const thisMonth = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Rome" }).slice(0, 7);
export const eur = (n) => `${Number(n || 0).toFixed(2)} \u20ac`;

export function EarningsRows({ rows, showAmount = true }) {
  return (
    <ul className="divide-y divide-slate-100 text-sm">
      {rows.map((r, i) => (
        <li key={`${r.job_id}-${r.user_id || ""}-${i}`} className="py-2 flex flex-wrap items-center gap-3">
          {r.status === "sbloccato" ? <Unlock className="w-4 h-4 text-emerald-600" /> : <Lock className="w-4 h-4 text-amber-600" />}
          <span className="flex-1 min-w-0 truncate text-slate-800">{r.date.split("-").reverse().join("/")} · {r.client_name}</span>
          <span className="text-slate-700 font-semibold">{r.hours} h{r.open && " (in corso)"}</span>
          {showAmount && <span className={`font-semibold ${r.status === "sbloccato" ? "text-emerald-700" : "text-amber-700"}`}>{eur(r.amount)}</span>}
        </li>
      ))}
    </ul>
  );
}

export function Totals({ t }) {
  return (
    <div className="grid grid-cols-3 gap-3" data-testid="earnings-totals">
      <div className="rounded-xl bg-emerald-50 p-3"><div className="text-xs text-emerald-700">Sbloccato</div><div className="font-display text-lg sm:text-xl font-extrabold text-emerald-800 whitespace-nowrap" data-testid="earnings-unlocked">{eur(t.unlocked)}</div></div>
      <div className="rounded-xl bg-amber-50 p-3"><div className="text-xs text-amber-700">Congelato</div><div className="font-display text-lg sm:text-xl font-extrabold text-amber-800 whitespace-nowrap" data-testid="earnings-frozen">{eur(t.frozen)}</div></div>
      <div className="rounded-xl bg-slate-50 p-3"><div className="text-xs text-slate-500">Ore</div><div className="font-display text-xl font-extrabold text-slate-900">{t.hours}</div></div>
    </div>
  );
}

export default function EarningsTab() {
  const [month, setMonth] = useState(thisMonth());
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/me/earnings?month=${month}`).then((r) => setD(r.data)).catch(() => setD(null));
  }, [month]);
  return (
    <div className="space-y-4" data-testid="earnings-tab">
      <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="h-10 rounded-md border border-slate-200 px-3 text-sm" data-testid="earnings-month-input" />
      {d && (
        <div className="rounded-2xl bg-slate-900 text-white p-5" data-testid="earnings-validated">
          <div className="text-xs uppercase tracking-widest text-slate-400 font-bold">Ore convalidate</div>
          <div className="font-display text-4xl font-extrabold mt-1" data-testid="earnings-validated-hours">{d.validated_hours} h</div>
          {d.open_hours > 0 && <div className="text-xs text-slate-400 mt-1">+ {d.open_hours} h in corso</div>}
          {d.scheduled_hours > 0 && <div className="text-xs text-slate-400 mt-1" data-testid="earnings-scheduled-hours">+ {d.scheduled_hours} h programmate nei prossimi giorni</div>}
          <div className="text-xs text-slate-400 mt-3 space-y-0.5" data-testid="earnings-projection">
            <div>Stima del mese finora: {eur(d.estimate)} ({eur(d.frozen)} in attesa del saldo cliente)</div>
            {month === thisMonth() && <div>Se continui a questo ritmo, a fine mese: circa {eur(d.projection)}</div>}
          </div>
        </div>
      )}
      <p className="text-xs text-slate-500">Le ore contano dall'arrivo in deposito, salvo penalità. La quota di ogni lavoro si sblocca quando il cliente ha saldato tutto.</p>
      {d && (d.rows.length ? <EarningsRows rows={d.rows} showAmount={false} /> : <p className="text-sm text-slate-400">Nessun lavoro in questo mese.</p>)}
    </div>
  );
}
